// extracted by mini-css-extract-plugin
export var box = "_6u-1";
export var checked = "_6u-2";
export var descriptionSpacer = "_6u-9";
export var disabled = "_6u-3";
export var icon = "_6u-6";
export var input = "_6u-0";
export var labelSpacer = "_6u-8";
export var medium = "_6u-5";
export var small = "_6u-4";
export var text = "_6u-7";